import { InvoiceArrivalDetailsFormValues } from "./types";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "./constants";

export interface InvoiceArrivalDetailsFormProps {
  children?: React.ReactNode;
  defaultFormValues?: Partial<InvoiceArrivalDetailsFormValues>;
}

export const InvoiceArrivalDetailsFormProvider = ({
  children,
  defaultFormValues,
}: InvoiceArrivalDetailsFormProps) => {
  const methods = useForm<InvoiceArrivalDetailsFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
